import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_COMMENT_MUTATION = gql`
  mutation addOrUpdateComment($input: CommentInput!) {
    addOrUpdateComment(input: $input){
      correlationId
    }
  }
`;

export const DELETE_COMMENT_MUTATION = gql`
  mutation deleteComment($commentId: Int!) {
    deleteComment(commentId: $commentId) {
      correlationId
    }
  }
`;